import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { OrganizationTabProps } from "../../../../../types/Applications";
import { dynamicImage } from "../../../../../utils";
import { Href, Print } from "../../../../../constants";
import PrintModal from "../PrintModal";
import { Image } from "../../../../../coreComponents/Image";

const OrganizationTabs: React.FC<OrganizationTabProps> = ({ user }) => {

  const [printModal, setPrintModal] = useState(false);
  const toggleCallback = useCallback((toggle: boolean) => setPrintModal(toggle), []);

  return (
    <>
      <div className="profile-mail">
        <div className="d-flex">
          <Image className="img-100 img-fluid m-r-20 rounded-circle" src={dynamicImage(`${user.avatar}`)} alt="" />
          <div className="flex-grow-1 mt-0">
            <h3><span className="f-w-600">{user.name}</span></h3>
            <p>{user.email}</p>
            <ul>
              <li>
                <Link to={Href} onClick={() => setPrintModal(!printModal)}>{Print}</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mail-general">
          <h6>{"General"}</h6>
          <p>{"Email Address"}: <span className="font-primary">{user.email}</span></p>
          <div className="gender">
            <h6>{"Personal"}</h6>
            <p>{"Gender"}: <span>{user.gender}</span></p>
          </div>
        </div>
      </div>
      {user && <PrintModal toggleCallback={toggleCallback} printModal={printModal} selectedUser={user} />}
    </>
  );
};
export default OrganizationTabs;